import React from 'react';
import './TwBadge.scss';
import { SxProps, Box } from '@mui/material';
import Expand from '@mui/icons-material/ExpandMore';

export interface TwBadgeProps {
  content: string | JSX.Element;
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error';
  className?: string;
  sx?: SxProps;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const TwBadge: React.FC<TwBadgeProps> = ({
  content,
  variant,
  className,
  sx,
  onClick
}): JSX.Element => {
  return (
    <div className="badge__group">
      {content && (
        <Box
          className={`badge__status ${variant ? `badge__${variant}` : ''} ${className}`}
          sx={sx}
          onClick={onClick}
        >
          {content}
          {onClick && (
            <Expand
              sx={{
                fontSize: '16px'
              }}
            />
          )}
        </Box>
      )}
    </div>
  );
};

export default TwBadge;
